import { createSlice } from '@reduxjs/toolkit';
import { clearReducers } from 'redux/logout';

export const initialState = {
  items: {},
  search: '',
  status: 'ACTIVE',
  pageable: {
    pageNumber: 0,
    pageSize: 10,
  },
  loaded: false,
};

const paquerypointSlice = createSlice({
  name: 'paquerypoint',
  initialState,
  reducers: {
    initial: () => {},
    fetch: (state) => {
      state.loaded = false;
    },
    success: (state, action) => {
      state.loaded = true;
      state.items = {};
      action.payload.forEach((paquerypoint) => {
        state.items[paquerypoint.id] = paquerypoint;
      });
    },
    failure: (state) => {
      state.loaded = true;
    },
    updatePageable: (state, action) => {
      state.pageable.pageNumber =
        action.payload.pageSize !== state.pageable.pageSize
          ? 0
          : action.payload.pageNumber;
      state.pageable.pageSize = action.payload.pageSize;
    },
    updateSearch: (state, action) => {
      state.pageable.pageNumber = 0;
      state.search = action.payload;
    },
    updateStatus: (state, action) => {
      state.pageable.pageNumber = 0;
      state.status = action.payload;
      state.items = {};
      state.loaded = false;
    },
    refreshPage: () => {},
  },
  extraReducers: {
    [clearReducers]: () => initialState,
  },
});

export const { name, reducer, actions } = paquerypointSlice;
